var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownloadAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1776_6325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1776_6325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64415 14.1375C2.53971 15.0125 3.61943 15.45 4.88332 15.45H8.29999V13.7833H4.88332C4.07777 13.7833 3.39027 13.4986 2.82082 12.9292C2.25138 12.3597 1.96665 11.6722 1.96665 10.8667C1.96665 10.0611 2.25138 9.37362 2.82082 8.80418C3.39027 8.23473 4.07777 7.95001 4.88332 7.95001H5.29999C5.29999 7.07501 5.59165 6.22418 6.17499 5.39751C6.75832 4.5714 7.57776 4.06112 8.63332 3.86668V8.90835L7.29999 7.61668L6.13332 8.78335L9.14521 11.7952C9.19565 11.7874 9.24734 11.7833 9.29999 11.7833H9.80001L12.8 8.78335L11.6333 7.61668L10.3 8.90835V3.86668C10.3 3.40835 10.1369 3.01585 9.81082 2.68918C9.48415 2.36307 9.09165 2.20001 8.63332 2.20001C7.56388 2.20001 6.55693 2.6514 5.61249 3.55418C4.66804 4.45696 4.07777 5.40835 3.84165 6.40835C2.7861 6.64446 1.93193 7.18612 1.27915 8.03335C0.626377 8.88057 0.299988 9.84585 0.299988 10.9292C0.299988 12.1931 0.748043 13.2625 1.64415 14.1375ZM16.9653 11.7833H18.6325C18.6331 11.7557 18.6333 11.7279 18.6333 11.7C18.6333 10.7417 18.3175 9.90474 17.6858 9.18918C17.0536 8.47418 16.2583 8.06112 15.3 7.95001C15.3 6.82501 15.0014 5.78696 14.4042 4.83585C13.8069 3.88418 12.9944 3.16529 11.9667 2.67918V4.61668C12.4667 5.01946 12.8694 5.5089 13.175 6.08501C13.4805 6.66168 13.6333 7.28335 13.6333 7.95001V9.61668H14.8833C15.4667 9.61668 15.9597 9.81807 16.3625 10.2208C16.7653 10.6236 16.9667 11.1167 16.9667 11.7C16.9667 11.728 16.9662 11.7558 16.9653 11.7833Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4411 12.7833C10.4222 12.7833 9.59998 13.6076 9.59998 14.6245V17.1349C9.59998 17.4585 9.86232 17.7208 10.1859 17.7208C10.5095 17.7208 10.7719 17.4585 10.7719 17.1349V16.4656H12.1104V17.1349C12.1104 17.4585 12.3727 17.7208 12.6963 17.7208C13.0199 17.7208 13.2823 17.4585 13.2823 17.1349V14.6245C13.2823 13.6055 12.4578 12.7833 11.4411 12.7833ZM10.7719 15.2937V14.6245C10.7719 14.2534 11.072 13.9552 11.4411 13.9552C11.8107 13.9552 12.1104 14.2538 12.1104 14.6245V15.2937H10.7719Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 16.549H15.504V13.3693C15.504 13.0457 15.2416 12.7833 14.918 12.7833C14.5944 12.7833 14.3321 13.0457 14.3321 13.3693V17.1349C14.3321 17.4585 14.5944 17.7208 14.918 17.7208H16.1733C16.4969 17.7208 16.7592 17.4585 16.7592 17.1349C16.7592 16.8113 16.4969 16.549 16.1733 16.549Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3113 16.549H18.642V13.3693C18.642 13.0457 18.3796 12.7833 18.056 12.7833C17.7324 12.7833 17.4701 13.0457 17.4701 13.3693V17.1349C17.4701 17.4585 17.7324 17.7208 18.056 17.7208H19.3113C19.6349 17.7208 19.8972 17.4585 19.8972 17.1349C19.8972 16.8113 19.6349 16.549 19.3113 16.549Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadAll);
export default __webpack_public_path__ + "static/media/ic-download-all.b29622bc9d2e99ea38299e96f2d7cc38.svg";
export { ForwardRef as ReactComponent };